import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class WeightedPrice extends Component {
  render() {
    return (
      <div className="card p-0">
        {this.props.weightedPriceList.length ?
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th>Item</th>
                <th>Brand</th>
                <th>Grade</th>
                <th className="hidden-xs-down">Total weight</th>
                <th>Weighted Price Avg</th>
              </tr>
            </thead>
            <tbody>
              {this.props.weightedPriceList.map((i, idx) => {
                return (
                  <tr key={idx}>
                    <td>{ i.item_name} </td>
                    <td>{ i.item_brand } </td>
                    <td>{ i.item_brand_grade.replace(
                          i.item_name, '').replace(
                            i.item_brand, '').replace(
                              /^\s+|\s+$/g,'')} </td>
                    <td className="hidden-xs-down">{ i.total_weight } </td>
                    <td> { i.weighted_price_avg}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        :
          <div className="shipment-no-items mb-0">
            No results
          </div>
        }
      </div>
    )
  }
}

WeightedPrice.propTypes = {
  weightedPriceList: PropTypes.array,
};
